import { defineSlotRecipe } from '@chakra-ui/react';
import { codeBlockAnatomy } from '@chakra-ui/react/anatomy';

export const codeblockRecipe = defineSlotRecipe({
  className: 'ac-codeblock',
  slots: codeBlockAnatomy.keys(),
  base: {
    root: {},
    codeText: {
      fontFamily: 'acMonospace',
      fontSize: '14px',
    },
  },
});
